import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';

export class CreditRedemptionStore extends Store {
  @observable public promptUsersToCheckCredits = false;
  @observable public hasCreditRedemptionIntent = false;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setPromptUsersToCheckCredits(promptUsersToCheckCredits: boolean) {
    this.promptUsersToCheckCredits = promptUsersToCheckCredits;
  }

  public setHasCreditRedemptionIntent(hasCreditRedemptionIntent: boolean) {
    this.hasCreditRedemptionIntent = hasCreditRedemptionIntent;
  }
}

CreditRedemptionStore.DEFAULTS = {
  promptUsersToCheckCredits: false,
  hasCreditRedemptionIntent: false
};
